import { MapSettings } from "./MapSettings";

export interface ILhlpTenantSettingsFactory {
    GetSettings(): LhlpTenantSettings;
}

export class LhlpTenantSettingsFactory implements ILhlpTenantSettingsFactory {

    public GetSettings(): LhlpTenantSettings {
        var s = $("#tenantSettings").data("tenantSettings");

        if (s) {           
            return new LhlpTenantSettings(s);
        }

        console.error("Tenant settings not found");
        return null;
    }
}

export class LhlpTenantSettings {
    public MapSettings: MapSettings;

    public constructor(obj) {        
        this.MapSettings = Object.assign(new MapSettings(), obj["MapSettings"]);
    }
}
